import { useEffect, useState } from "react";
import { Card, Col, Row, message, Tooltip, Modal, Button, Spin, Select, Grid, Input , Tabs, Table, Typography  } from "antd";
import AppLayout from "../layout/AppLayout";
import { fetchSolvingProcessesMarketplace } from "../services/accessAPI";
import "./SolvingProcessesMarketplace.css";
import { useNavigate } from "react-router-dom";
import { 
  InfoCircleOutlined, 
  SettingOutlined, 
  CodeOutlined, 
  ToolOutlined, 
  DatabaseOutlined, 
  ExclamationCircleOutlined 
} from '@ant-design/icons';



const { Search } = Input;
const { Option } = Select;
const { useBreakpoint } = Grid;
const { TabPane } = Tabs;
const { Title } = Typography;

const SolvingProcessesMarketplace = () => {
  const navigate = useNavigate();
  const screens = useBreakpoint();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterCategory, setFilterCategory] = useState("description");
  const [searchTerm, setSearchTerm] = useState("");
  const [visibleModal, setVisibleModal] = useState(false);
  const [selectedProcess, setSelectedProcess] = useState(null);
  const [uniqueInterfaceFromOptions, setUniqueInterfaceFromOptions] = useState([]);
  const [uniqueInterfaceToOptions, setUniqueInterfaceToOptions] = useState([]);
  const [combinedInterfaceOptions, setCombinedInterfaceOptions] = useState([]);
  const [uniqueRealWorldProblems, setUniqueRealWorldProblems] = useState([]);

  const searchStyle = {
    width: screens.xs ? "100%" : "30%",
  };

  useEffect(() => {
    const loadApiConfig = async () => {
      try {
        const apiList = await fetchSolvingProcessesMarketplace();
        if (apiList) {
          setData(apiList);
          setFilteredData(apiList);
          extractUniqueValues(apiList);
        } else {
          message.warning("No data available.");
        }
      } catch (error) {
        console.error("Error fetching API list:", error);
        message.error("Failed to load marketplace data.");
      } finally {
        setLoading(false);
      }
    };
    loadApiConfig();
  }, []);

  const extractUniqueValues = (apiList) => {
    const interfaceFromSet = new Set();
    const interfaceToSet = new Set();
    const combinedSet = new Set();
    const realWorldProblemSet = new Set();

    apiList.forEach((process) => {
      process.intermodalInterfaces.forEach(({ interfaceFrom, interfaceTo }) => {
        const normalizedFrom = interfaceFrom.toUpperCase(); // Convert to toUpperCase
        const normalizedTo = interfaceTo.toUpperCase(); // Convert to toUpperCase

        interfaceFromSet.add(normalizedFrom);
        interfaceToSet.add(normalizedTo);
        combinedSet.add(`${normalizedFrom} → ${normalizedTo}`);
      });

      process.realWorldProblems.forEach((problem) => realWorldProblemSet.add(problem));
    });

    setUniqueInterfaceFromOptions(Array.from(interfaceFromSet));
    setUniqueInterfaceToOptions(Array.from(interfaceToSet));
    setCombinedInterfaceOptions(Array.from(combinedSet));
    setUniqueRealWorldProblems(Array.from(realWorldProblemSet));
  };

  useEffect(() => {
    if (!searchTerm) {
      setFilteredData(data);
      return;
    }

    const filtered = data.filter((process) => {
      if (filterCategory === "interfaceFrom") {
        return process.intermodalInterfaces.some(
          (item) => item.interfaceFrom.toUpperCase() === searchTerm.toUpperCase()
        );
      }
      if (filterCategory === "interfaceTo") {
        return process.intermodalInterfaces.some((item) => item.interfaceTo.toUpperCase() === searchTerm.toUpperCase());
      }
      if (filterCategory === "interfaceFromANDinterfaceTo") {
        return process.intermodalInterfaces.some(
          (item) =>
            `${item.interfaceFrom.toUpperCase()} → ${item.interfaceTo.toUpperCase()}` === searchTerm.toUpperCase()
        );
      }
      if (filterCategory === "realWorldProblem") {
        return process.realWorldProblems.includes(searchTerm);
      }
      if (filterCategory === "description") {
        const normalizedName = process.name.toLowerCase();
        const normalizedDescription = process.description.toLowerCase();
        const normalizedSearchTerm = searchTerm.toLowerCase();

        const matchesName = normalizedName.includes(normalizedSearchTerm);
        const matchesDescription = normalizedDescription.includes(normalizedSearchTerm);

        return ( matchesName || matchesDescription );
      }
      return true;
    });

    setFilteredData(filtered);
  }, [searchTerm, filterCategory, data]);

  const runSolvingProcessesClick = (process) => {

    const descriptions = process.endpoints.map((endpoint) => ({
      method: endpoint.method,
      path: endpoint.path,
      description: endpoint.description,
      basePath: process.baseUrl,
      expectedInput: endpoint.expectedInput,
      name: process.name,
      id: process.id,
      expectedOutput: endpoint.expectedOutput
    }));
    const formatValue = descriptions[0].expectedInput[0].format;
    const UrlIframe = descriptions[0].basePath;
    const isIframe = formatValue === "iframe";
    setTimeout(() => {
      if (isIframe) {
        navigate("/SolverIframe", { state: { url: UrlIframe } });
      } else {
        navigate("/Results", {
          state: { description: descriptions[0], pageToNavigate: "SolvingProcesses_Marketplace" },
        });
      }
    }, 300);
  };

  const handleSelectChange = (value) => {
  setFilterCategory(value);
  setSearchTerm(null);
  };

  const handleCardButtonClick = (process) => {
    setSelectedProcess(process);
    setVisibleModal(true);
  };

  const handleModalClose = () => {
    setVisibleModal(false);
    setSelectedProcess(null);
  };
console.log(selectedProcess);
  return (
    <AppLayout>
      <div className="SolvingProcessesMarketplace">
        <h1 style={{ marginBottom: 20, color: "#142745" }}>Solving Processes Marketplace</h1>
        <p>Please select your preferred search option.</p>
        <div style={{ marginBottom: 20, display: "flex", flexWrap: "wrap", gap: "10px" }}>
          <Select
            style={{ width: 250 }}
            value={filterCategory}
            onChange={handleSelectChange}
            placeholder="Select Category"
          >
            <Option value="description">All Solving Processes</Option>
            <Option value="interfaceFrom">Interface From</Option>
            <Option value="interfaceTo">Interface To</Option>
            <Option value="interfaceFromANDinterfaceTo">Interface From → Interface To</Option>
            <Option value="realWorldProblem">Real World Problem</Option>
          </Select>

          {filterCategory !== "description"  && (
            <Select style={{ width: 750 }} value={searchTerm} onChange={setSearchTerm} placeholder="Select Option">
              {filterCategory === "interfaceFromANDinterfaceTo" &&
                combinedInterfaceOptions.map((combined, idx) => (
                  <Option key={idx} value={combined}>
                    {combined}
                  </Option>
                ))}
              {filterCategory === "realWorldProblem" &&
                uniqueRealWorldProblems.map((problem, idx) => (
                  <Option key={idx} value={problem}>
                    {problem}
                  </Option>
                ))}
              {filterCategory === "interfaceTo" &&
                uniqueInterfaceToOptions.map((interfaceTo, idx) => (
                  <Option key={idx} value={interfaceTo}>
                    {interfaceTo}
                  </Option>
                ))}
              {filterCategory === "interfaceFrom" &&
                uniqueInterfaceFromOptions.map((interfaceFrom, idx) => (
                  <Option key={idx} value={interfaceFrom}>
                    {interfaceFrom}
                  </Option>
                ))}
            </Select>
          )}
          {filterCategory === "description" && (
            <Search
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={searchStyle}
              allowClear
              className="custom-search"
            />
          )}
          {/* <Button onClick={handleClearFilters} style={{ marginLeft: 10 }}>
            Clear Filters
          </Button> */}
        </div>

        {loading ? (
          <Spin tip="Loading...">
            <div style={{ height: "50vh", display: "flex", justifyContent: "center", alignItems: "center" }} />
          </Spin>
        ) : (
          <div style={{ maxHeight: "65vh", overflowY: "auto", paddingRight: "10px" }}>
            <Row gutter={[16, 16]}>
              {filteredData.map((process) => (
                <Col key={process.id} xs={24} sm={24} md={12} lg={12} xl={8} xxl={8}>
                  <Card
                    title={
                      <Tooltip title={process.name}>
                        <span
                          style={{
                            display: "block",
                            whiteSpace: "normal",
                            wordWrap: "break-word",
                            overflowWrap: "break-word",
                          }}
                        >
                           {process.shortDescription}
                        </span>
                      </Tooltip>
                    }
                    bordered
                    style={{
                      height: "100%", // Makes sure the card takes full height
                      padding: 20,
                      borderRadius: 10,
                      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                      backgroundColor: "#ffffff",
                      display: "flex",
                      flexDirection: "column",
                    }}
                    styles={{
                      body: {
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                      },
                    }}
                  >
                    <div style={{ flexGrow: 1 }}>
                      <p>
                        <strong>Description:</strong> {process.description}
                      </p>
                      <p>
                        <strong>ID:</strong> {process.name}
                      </p>
                    </div>
                    <div className="button-container">
                      <Button
                        type="primary"
                        className="readmoresolving"
                        block
                        onClick={() => handleCardButtonClick(process)}
                      >
                        Read More
                      </Button>
                      <Button className="" block onClick={() => runSolvingProcessesClick(process)}>
                        Run
                      </Button>
                    </div>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
        )}

        {selectedProcess && (
<Modal
  title={
    <h2 className="text-2xl font-semibold text-center m-0">
      {selectedProcess.shortDescription}
    </h2>
  }
  open={visibleModal}
  onCancel={handleModalClose}
  footer={[
    <Button key="back" onClick={handleModalClose}>
      Close
    </Button>,
  ]}
  width={900}
  styles={{
    body: {
      padding: "20px",
      maxHeight: "80vh",
      overflowY: "auto",
    },
  }}
>
  <Tabs defaultActiveKey="1" type="card" size="small">
    <TabPane 
      tab={
        <span>
          <InfoCircleOutlined />
          Overview
        </span>
      } 
      key="1"
    >
      <div className="space-y-6">
        {/* Description */}
        <section>
          <h5 className="text-lg font-semibold mb-3">Description of Solving Process:</h5>
          {/* {selectedProcess.endpoints.map((endpoint, index) => (
            <div key={index}>
              <p className="text-gray-700">{endpoint.description}</p>
            </div>
          ))} */}
        {selectedProcess?.description ? (
            <p>{selectedProcess.description}</p>
          ) : (
            <p>No description available</p>
          )}
        </section>

        {/* ID */}
        <section>
          <h5 className="text-lg font-semibold mb-3">ID of Solving Process:</h5>
          <p className="text-gray-700 font-mono bg-gray-50 p-2 rounded">
            {selectedProcess.name}
          </p>
        </section>

        {/* Added Value */}
        <section>
          <h5 className="text-lg font-semibold mb-3">Added Value:</h5>
          <p className="text-gray-700">{selectedProcess.addedValue}</p>
        </section>
      </div>
    </TabPane>

    <TabPane 
      tab={
        <span>
          <CodeOutlined />
          Interfaces
        </span>
      } 
      key="2"
    >
      <Title level={4}>Intermodal Interfaces</Title>
      <Table
        columns={[
          { title: "Interface From", dataIndex: "interfaceFrom", key: "interfaceFrom" },
          { title: "Interface To", dataIndex: "interfaceTo", key: "interfaceTo" },
        ]}
        dataSource={selectedProcess.intermodalInterfaces.map((item, index) => ({
          key: index,
          interfaceFrom: item.interfaceFrom,
          interfaceTo: item.interfaceTo,
        }))}
        pagination={selectedProcess.intermodalInterfaces.length > 3 ? { pageSize: 3 } : false}
        rowKey="key"
        size="small"
      />
    </TabPane>

    <TabPane 
      tab={
        <span>
          <ToolOutlined />
          Solvers
        </span>
      } 
      key="3"
    >
      <div className="space-y-6">
        {/* Solvers */}
        <section>
          <h5 className="text-lg font-semibold mb-3">Solvers:</h5>
          <div className="flex flex-wrap gap-2">
            {selectedProcess.solvers.map((solver, index) => (
              <span 
                key={index}
                className="px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm font-medium"
              >
                {solver}
              </span>
            ))}
          </div>
        </section>
      </div>
    </TabPane>

    <TabPane 
      tab={
        <span>
          <DatabaseOutlined />
          Legacy Systems
        </span>
      } 
      key="4"
    >
      <div className="space-y-6">
        {/* Legacy Systems */}
        <section>
          <h5 className="text-lg font-semibold mb-3">Legacy Systems:</h5>
          <div className="flex flex-wrap gap-2">
            {selectedProcess.legacySystems.map((system, index) => (
              <span 
                key={index}
                className="px-3 py-1 bg-orange-100 text-orange-800 rounded-full text-sm font-medium"
              >
                {system}
              </span>
            ))}
          </div>
        </section>
      </div>
    </TabPane>

    <TabPane 
      tab={
        <span>
          <ExclamationCircleOutlined />
          Problems
        </span>
      } 
      key="5"
    >
      <div className="space-y-6">
        {/* Real World Problems */}
        <section>
          <h5 className="text-lg font-semibold mb-3">Real-World Problems:</h5>
          <div className="space-y-3">
            {selectedProcess.realWorldProblems.map((problem, index) => (
              <div 
                key={index}
                className="p-3 bg-red-50 border-l-4 border-red-400 rounded-r-lg"
              >
                <p className="text-red-800 m-0">{problem}</p>
              </div>
            ))}
          </div>
        </section>
      </div>
    </TabPane>
  </Tabs>
</Modal>

        )}
      </div>
    </AppLayout>
  );
};

export default SolvingProcessesMarketplace;
